import React from 'react';
import './LinkPreview.css';
import { IconLink, IconExternalLink } from '@tabler/icons-react';

const isValidUrl = (url) => {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
};

export default function LinkPreview({ url, title, description, image }) {
    if (!url || !isValidUrl(url)) {
        return null; // Don't render if the URL is invalid or missing
    }

    // Only attempt to construct URL object if it's valid
    const hostname = new URL(url).hostname;

    return (
        <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="link-preview"
        >
            <div className="link-preview__content">
                <div className="link-preview__text">
                    <div className="link-preview__url">
                        <IconLink size={16} />
                        <span>{hostname}</span>
                    </div>
                    <h4 className="link-preview__title">
                        {title}
                        <IconExternalLink size={16} />
                    </h4>
                    {description && (
                        <p className="link-preview__description">
                            {description}
                        </p>
                    )}
                </div>
                {image && (
                    <div className="link-preview__image">
                        <img src={image} alt={title} />
                    </div>
                )}
            </div>
        </a>
    );
} 